import { LeagueFilterProvider } from './contexts/league-filter-context';
import { LeagueFilterHeader } from './components/league-filter-header';
import { LeagueFilterResult } from './components/league-filter-result';
import { LeagueFilterFooter } from './components/league-filter-footer';

export const LeagueFilter = () => {
	return (
		<div className="select-league">
			<LeagueFilterProvider>
				<LeagueFilterHeader />
				<div className="select-league__content">
					<LeagueFilterResult />
				</div>
				<LeagueFilterFooter />
			</LeagueFilterProvider>
		</div>
	);
};